var unavailable = 'UNAVAILABLE';
var defaultItemLimit = 10;
export var transformResults = function transformResults(searchItems) {
  return searchItems.sections.map(function (section) {
    return {
      results: section.searchResults.slice(0, (section === null || section === void 0 ? void 0 : section.resultLimit) || defaultItemLimit).map(function (item) {
        return {
          containerId: item.containerId || unavailable,
          isRecentResult: !!item.isRecentResult,
          resultContentId: item.id,
          resultType: section.id
        };
      }),
      sectionId: section.id
    };
  });
};